module.exports = __webpack_public_path__ + "img/Slagboom-auto.c6cadcb1.svg";